import type { State } from '../StateTypes';
import type { IKompisTranslations } from '@inter-ikea-kompis/types';
import type {
  IExtendedTranslations,
  IStorageTwoTranslations,
} from './translationsTypes';

/**
 * Select translations
 * @returns {IExtendedTranslations} The translations
 */
export const selectTranslations = (state: State): IExtendedTranslations =>
  state.translations;

/**
 * Select Kompis translations
 * @returns {IKompisTranslations} The Kompis translations
 */
export const selectKompisTranslations = (state: State): IKompisTranslations =>
  selectTranslations(state).kompis;

/**
 * Select StorageTwo translations
 * @returns {IStorageTwoTranslations} The StorageTwo translations
 */
export const selectStorageTwoTranslations = (
  state: State
): IStorageTwoTranslations => selectTranslations(state).storagetwo;

/**
 * Select translations flattened and including both Kompis and StorageTwo translations
 * @returns {IKompisTranslations & IStorageTwoTranslations} The flattened translations
 */
export const selectFlattenedTranslations = (
  state: State
): IKompisTranslations & IStorageTwoTranslations => ({
  ...selectKompisTranslations(state),
  ...selectStorageTwoTranslations(state),
});
